import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function SeaPlane(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M19.814 3.03l-.833 4.166A1 1 0 0118 8c-2.099 0-3.469-.265-4.652-.523a142.9 142.9 0 01-.289-.063C12.027 7.187 11.18 7 10 7c-.902 0-1.697.681-2.106 1.448v.002l-.002.002A1 1 0 017.005 9C6.064 9.02 5 9.43 5 10.5c0 1.067 1.056 1.474 1.994 1.5H20a1 1 0 001-1V4.49a1.49 1.49 0 00-1.186-1.46zM7 14h.234l-1.8 3H3c-.54 0-1 .462-1 1.002C2.009 20.865 4.194 23 7 23h10c2.674 0 4.974-2.337 5-4.998V18a1 1 0 00-1-1h-2.434l-1.8-3H20a3 3 0 003-3V4.49A3.49 3.49 0 0019.51 1c-.773 0-1.439.546-1.59 1.304l-.737 3.68c-1.449-.055-2.467-.256-3.41-.461l-.297-.066C12.45 5.231 11.406 5 10 5c-1.359 0-2.348.684-2.957 1.293-.27.27-.478.537-.628.753-1.026.138-2.065.557-2.727 1.384C3.258 8.967 3 9.658 3 10.5V7a1 1 0 00-2 0v7a1 1 0 102 0v-3.5c0 .842.259 1.533.688 2.07.417.52.95.842 1.427 1.04A5.01 5.01 0 007 14zm.766 3l1.8-3h4.868l1.8 3H7.766zm-3.59 2C4.58 20.325 5.643 21 7 21h10c1.357 0 2.419-.675 2.825-2H4.175z",
    clipRule: "evenodd"
  }));
}

export default SeaPlane;